import React, {useEffect} from 'react';
import GuestBar from "../../../components/GuestInfo/GuestBar";
import {Breadcrumbs, Container, Grid, Link, Typography} from "@mui/material";
import GuestInfoStepper from "../../../components/GuestInfo/GuestInfoStepper";
import {useDispatch, useSelector} from "react-redux";
import {setStep} from "../../../redux/actions/stepActions";
import {Formik} from "formik";
import MedicalAndInsuranceForm from "../../../components/GuestInfo/GuestForm/MedicalAndInsuranceForm";
import {getBookingFormData, updateBookingFormData} from "../../../redux/actions/bookingFormActions";
import {Link as RouterLink, useHistory, useParams} from "react-router-dom";
import {useIsAuthenticated} from "react-auth-kit";
import {parseDate, showAlertAutoDis} from "../../../utils/utils";
import {endOfDay, format, isPast, isAfter, parse, startOfDay} from "date-fns";
import ValidateAccess from "../../../components/ValidateAccess/ValidateAccess";
import PreTripCard from "../../../components/GuestInfo/MyBooking/PreTripCard";


const MedicalInsurancePage = () => {
    ValidateAccess();
    const dispatch = useDispatch();
    const history = useHistory();
    const {id} = useParams();
    const {booking, form} = useSelector(state => state.bookingForm);
    const isAuth = useIsAuthenticated();

    const initialValues = {
        emergContact: form?.emergContact || '',
        emergPhone: form?.emergPhone || '',
        emergRelation: form?.emergRelation || '',
        menu: form?.menu || 'regular',
        allergyYesNo: !!(form?.allergyYesNo),
        allergies: form?.allergies || '',
        medicalYesNo: !!(form?.medicalYesNo),
        medical: form?.medical || '',
        diveInsOption: form?.diveInsProvider ? 'alreadyOwn' : 'purchase',
        diveInsProvider: form?.diveInsProvider || '',
        diveInsNum: form?.diveInsNum || '',
        diveInsExpiryDate: parseDate(form?.diveInsExpiryDate),
        travelIns: form?.travelIns || 'yes',
        insuranceProvider: form?.insuranceProvider || '',
    };

    useEffect(() => {
        dispatch(setStep(2));
    }, []);

    useEffect(() => {
        if (!booking || form.guestFk !== parseInt(id))
            getGuestAndTrip().catch();
    }, [booking?.id]);

    const getGuestAndTrip = async () => {
        const accessToken = sessionStorage.getItem('accessToken');
        dispatch(getBookingFormData(id, accessToken));
    };

    const handleSubmit = async (values) => {
        try {
            const params = {...values};
            if (booking?.trip?.location?.tripTypeFk !== 2) {

                if (!values['diveInsNum'])
                    return showAlertAutoDis({
                        title: 'Error',
                        text: 'Dive Insurance Number is required.'
                    });

                if (!values['diveInsExpiryDate'] || isPast(endOfDay(values['diveInsExpiryDate'])))
                    return showAlertAutoDis({
                        title: 'Error',
                        text: 'Your dive insurance expiry date must be a future date.'
                    });

                const returnDate = startOfDay(parse(booking.trip.returndate, 'yyyy-MM-d', new Date()));
                const expiry = endOfDay(values['diveInsExpiryDate'])
                if (isAfter(returnDate, expiry)) {
                    return showAlertAutoDis({
                        title: 'Error',
                        text: `Your dive insurance expiry date must be after the return date of your trip (${format(returnDate, 'LLLL d, yyyy')}).`
                    });
                }

                params['diveInsExpiryDate'] = values['diveInsExpiryDate'] ? format(values['diveInsExpiryDate'], 'yyyy-MM-dd') : null;
            }
            if (values['menu'] === 'regular')
                params['menu'] = '';

            const access = sessionStorage.getItem('accessToken');
            if (access) params['guestCode'] = access;

            dispatch(updateBookingFormData(params, id));

            let url = `/booking/guest/${id}/diving`;
            if (booking.trip.location.tripTypeFk === 2)
                url = `/booking/guest/${id}/extra-activities`;
            return history.push(url);
        } catch (e) {
            return showAlertAutoDis({title: 'Error', text: 'Unable to update guest data.'});
        }
    };

    return (
        <>
            {isAuth() && booking && <GuestBar>
                <Breadcrumbs aria-label="breadcrumb" separator={'>'}>
                    <Link component={RouterLink} underline="hover" color="inherit" to="/booking/my-bookings">
                        Bookings
                    </Link>
                    <Link component={RouterLink} underline="hover" color="inherit"
                          to={`/booking/my-bookings/${booking.id}`}>
                        {format(parse(booking.tripDate, 'yyyy-MM-dd', new Date()), 'LLLL d, yyyy')}
                    </Link>
                    <Typography
                        color="text.primary">{form?.guestInfo?.firstName ? `${form.guestInfo.firstName} ${form.guestInfo.lastName}` : 'Guest Form'}</Typography>
                </Breadcrumbs>
            </GuestBar>}
            {booking && <Container>
                <GuestInfoStepper/>
                <div style={{marginTop: 50}}>
                    <Grid container spacing={3} sx={{px: {xs: '1.6rem', lg: '0'}}}>
                        <Grid item xs={12} sm={12}>
                            {booking.trip && <PreTripCard booking={booking}/>}
                        </Grid>
                        <Grid item xs={12} style={{marginTop: 50}}>
                            <Formik initialValues={initialValues} onSubmit={handleSubmit}>
                                {(props) => <MedicalAndInsuranceForm {...props} />}
                            </Formik>
                        </Grid>
                    </Grid>
                </div>
            </Container>}
        </>
    );
};

export default MedicalInsurancePage;